import { lookupRouteName } from './lookupConstants';

export const reportTimeSpanOptions = [
	{ title: 'Current Day', checked: false, value: 0 },
	{ title: 'Day Before', checked: false, value: -1 },
	{ title: 'Week Before', checked: true, value: -7 },
	{ title: 'Two Weeks Before', checked: false, value: -14 },
	{ title: 'Month Before', checked: false, value: -30 },
	{ title: 'All', checked: false, value: null },
	{ title: 'All With Value', checked: false, value: null },
	{ title: 'All With No Value', checked: false, value: null },
];

export const excludedColumns = {
	warehouseFulfillmentOrders: ['assignedRate', 'shippingCost', 'orderType', 'orderChannel'], // Columns which are not rendered for warehouse
};

// Filter types:
// 1 = Searchable and paginated filter
// 2 = Date Time filter
// 3 = Yes/No filter
export const reportCategoryColumns = {
	containers: [],
	products: [],
	marketplaceOrders: [],
	fulfillmentShipments: [
		{
			filterType: 1,
			columnKey: 'trackingNumber',
			title: 'SHIPMENTSTATUSVIEW.TRACKINGNUMBER',
			service: 'shipmentInfoService',
			shippedOnly: true,
			excludeShipmentsWithNoCarrier: true,
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'trackingNumber',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrder.order.channel.name',
			embed: ['fulfillmentOrder', 'fulfillmentOrder.order', 'fulfillmentOrder.order.channel'],
			title: 'SHIPMENTSTATUSVIEW.CHANNEL',
			service: 'channelService',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrder.order.channel.channelType.name',
			embed: [
				'fulfillmentOrder',
				'fulfillmentOrder.order',
				'fulfillmentOrder.order.channel',
				'fulfillmentOrder.order.channel.channelType',
			],
			title: 'SHIPMENTSTATUSVIEW.CHANNELTYPE',
			lookupConstant: lookupRouteName.channelType,
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrder.fulfillmentOrderId',
			embed: ['fulfillmentOrder'],
			title: 'SHIPMENTSTATUSVIEW.FULFILLMENTORDERID',
			sortBy: 'desc',
			service: 'fulfillmentOrderService',
			filterKey: 'fulfillmentOrderId',
			shippedOnly: true,
			excludeShipmentsWithNoCarrier: true,
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrder.order.orderNumber',
			embed: ['fulfillmentOrder', 'fulfillmentOrder.order'],
			title: 'SHIPMENTSTATUSVIEW.ORDERNUMBER',
			service: 'orderService',
			filterKey: 'orderNumber',
			shippedOnly: true,
			excludeShipmentsWithNoCarrier: true,
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			// TEST
			filterType: 4,
			columnKey: 'cost',
			title: 'SHIPMENTSTATUSVIEW.COST',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 3,
			columnKey: 'isBuyShipping',
			title: 'SHIPMENTSTATUSVIEW.ISBUYSHIPPING',
			service: 'orderService',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrder.carrierService.name',
			embed: ['fulfillmentOrder', 'fulfillmentOrder.carrierService'],
			title: 'SHIPMENTSTATUSVIEW.CARRIERSERVICE',
			filterKey: 'name',
			service: 'carrierServiceService',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrder.fulfillmentOrderStatus.name',
			embed: ['fulfillmentOrder', 'fulfillmentOrder.fulfillmentOrderStatus'],
			title: 'SHIPMENTSTATUSVIEW.FULFILLMENTORDERSTATUS',
			lookupConstant: lookupRouteName.fulfillmentOrderStatus,
			filterKey: 'name',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'carrierDeliveryStatus.name',
			embed: ['carrierDeliveryStatus'],
			title: 'SHIPMENTSTATUSVIEW.CARRIERDELIVERYSTATUS',
			lookupConstant: lookupRouteName.carrierDeliveryStatus,
			filterKey: 'name',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'carrierDeliveryStatus.shipmentInfoDeliveryStatus.name',
			embed: ['carrierDeliveryStatus', 'carrierDeliveryStatus.shipmentInfoDeliveryStatus'],
			title: 'SHIPMENTSTATUSVIEW.SHIPMENTINFODELIVERYSTATUS',
			lookupConstant: lookupRouteName.shipmentInfoDeliveryStatus,
			filterKey: 'name',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 4,
			columnKey: 'zone',
			title: 'SHIPMENTSTATUSVIEW.ZONE',
			filterKey: 'zone',
			service: 'shipmentInfoService',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 2,
			columnKey: 'carrierPickupDate',
			title: 'SHIPMENTSTATUSVIEW.CARRIERPICKUPDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 2,
			columnKey: 'deliveryDate',
			title: 'SHIPMENTSTATUSVIEW.DELIVERYDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 2,
			columnKey: 'estimatedArrivalDate',
			title: 'SHIPMENTSTATUSVIEW.ESTIMATEDDELIVERYDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 2,
			columnKey: 'shippingDate',
			title: 'SHIPMENTSTATUSVIEW.SHIPPINGDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
	],
	fulfillmentOrders: [
		{
			filterType: 1,
			columnKey: 'fulfillmentOrderStatus',
			title: 'ORDERVIEW.STATUS',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			lookupConstant: lookupRouteName.fulfillmentOrderStatus,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'fulfillmentOrderId',
			sortBy: 'desc',
			title: 'ORDERVIEW.FULFILLMENTORDERID',
			service: 'fulfillmentOrderService',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			numericSpecific: null,
			numericStart: null,
			numericEnd: null,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'carrier',
			title: 'ORDERVIEW.ASSIGNEDCARRIER',
			service: 'carrierService',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'carrierService',
			title: 'ORDERVIEW.ASSIGNEDCARRIERSERVICE',
			service: 'carrierServiceService',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'warehouse',
			title: 'ORDERVIEW.ASSIGNEDWAREHOUSE',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			service: 'applicationService',
			filterKey: 'applicationTitle',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'productQuantityPerSku',
			title: 'ORDERVIEW.PRODUCTSKU',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			service: 'productService',
			filterKey: 'mainSku',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 4,
			columnKey: 'productQuantity',
			title: 'ORDERVIEW.QUANTITY',
			isSelected: true,
			isFilterable: true,
			specificNumber: '',
			numberRangeStart: '',
			numberRangeEnd: '',
		},
		{
			filterType: 2,
			columnKey: 'orderDateTime',
			title: 'ORDERVIEW.ORDERDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 2,
			columnKey: 'fulfillmentOrderShipByLocalDate',
			title: 'ORDERVIEW.SHIPBYDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 2,
			columnKey: 'whShipByChannelDate',
			title: 'ORDERVIEW.WHSHIPBYDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 1,
			columnKey: 'orderChannel',
			title: 'ORDERVIEW.CHANNEL',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			service: 'channelService',
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'orderNumber',
			title: 'ORDERVIEW.ORDERNUMBER',
			service: 'orderService',
			isSearchable: true,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			columnKey: 'customerServiceOrderNumber',
			title: 'ORDERVIEW.CUSTOMERSERVICEORDERNUMBER',
			isSelected: true,
			isFilterable: false,
		},
		{
			columnKey: 'referenceNumber',
			title: 'ORDERVIEW.REFERENCENUMBER',
			isSelected: true,
			isFilterable: false,
		},
		{
			filterType: 2,
			columnKey: 'fulfillmentOrderDeliverByLocalDate',
			title: 'ORDERVIEW.DELIVERBYDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 1,
			columnKey: 'orderChannelType',
			title: 'ORDERVIEW.CHANNELTYPE',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			lookupConstant: lookupRouteName.channelType,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 3,
			columnKey: 'isBuyShipping',
			title: 'ORDERVIEW.ISBUYSHIPPING',
			isSelected: true,
			isFilterable: true,
			selectedValue: null,
		},
		{
			filterType: 3,
			columnKey: 'primeOrder',
			title: 'ORDERVIEW.ISPRIME',
			isSelected: true,
			isFilterable: true,
			selectedValue: null,
		},
		{
			filterType: 1,
			columnKey: 'orderType',
			title: 'ORDERVIEW.ORDERTYPE',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			lookupConstant: lookupRouteName.orderType,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'orderConfirmationType',
			title: 'ORDERVIEW.CONFIRMATIONTYPE',
			isSelected: true,
			isFilterable: true,
			isSearchable: false,
			isPartiallySelected: false,
			isFilterable: true,
			lookupConstant: lookupRouteName.confirmationType,
			filterKey: 'name',
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'source',
			title: 'ORDERVIEW.CHANNELSOURCE',
			service: 'orderService',
			isSearchable: false,
			getDistinctValues: true,
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'onHoldReason',
			title: 'ORDERVIEW.ONHOLDREASON',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			lookupConstant: lookupRouteName.onHoldReason,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'replacementReason',
			title: 'ORDERVIEW.REPLACEMENTREASON',
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			lookupConstant: lookupRouteName.replacementReason,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 3,
			columnKey: 'deliveryReplacement',
			title: 'ORDERVIEW.ISREPLACEMENT',
			isSelected: true,
			isFilterable: true,
			selectedValue: null,
		},
		{
			filterType: 1,
			getDistinctValues: true,
			columnKey: 'requiredCarrierService',
			title: 'ORDERVIEW.REQUIREDCARRIERSERVICE',
			isSelected: true,
			isFilterable: true,
			service: 'orderService',
			isSearchable: false,
			isPartiallySelected: false,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 4,
			columnKey: 'shippingCost',
			title: 'ORDERVIEW.SHIPPINGCOST',
			isSelected: true,
			isFilterable: true,
			specificNumber: '',
			numberRangeStart: '',
			numberRangeEnd: '',
		},
		{
			columnKey: 'trackingNumbers',
			title: 'ORDERVIEW.TRACKINGNUMBER',
			isSelected: true,
			isFilterable: false,
		},
		{
			filterType: 1,
			columnKey: 'deliveryStatus',
			title: 'ORDERVIEW.CARRIERDELIVERYSTATUS',
			isSelected: true,
			isFilterable: true,
			isSearchable: false,
			isSelected: true,
			isPartiallySelected: false,
			filterKey: 'name',
			lookupConstant: lookupRouteName.carrierDeliveryStatus,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 2,
			columnKey: 'shippingDateTime',
			title: 'ORDERVIEW.SHIPPEDDATE',
			isSelected: true,
			isFilterable: true,
			dateTimeOptions: reportTimeSpanOptions,
			useSpecificDate: false,
			specificDate: null,
		},
		{
			filterType: 4,
			columnKey: 'assignedRate',
			title: 'ORDERVIEW.ASSIGNEDRATE',
			isSelected: true,
			isFilterable: true,
			specificNumber: '',
			numberRangeStart: '',
			numberRangeEnd: '',
		},
		{
			filterType: 1,
			columnKey: 'pallet',
			title: 'ORDERVIEW.PALLETNAME',
			service: 'palletService',
			filterKey: 'name',
			isSelected: true,
			isFilterable: true,
			isSearchable: true,
			isPartiallySelected: false,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 4,
			columnKey: 'pickingBatchNumber',
			title: 'FULFILLMENTORDER.PICKINGBATCH.NAME',
			isSelected: true,
			isFilterable: true,
			specificNumber: '',
			numberRangeStart: '',
			numberRangeEnd: '',
		},
		{
			filterType: 4,
			columnKey: 'zone',
			title: 'ORDERVIEW.ZONE',
			isSelected: true,
			isFilterable: true,
			specificNumber: '',
			numberRangeStart: '',
			numberRangeEnd: '',
		},
		{
			filterType: 1,
			getDistinctValues: true,
			columnKey: 'shippingZipCode',
			title: 'ORDERVIEW.SHIPPINGADDRESSZIPCODE',
			isSelected: true,
			isFilterable: true,
			service: 'orderService',
			isSearchable: true,
			isPartiallySelected: false,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			columnKey: 'shippingState',
			title: 'ORDERVIEW.STATE',
			isSelected: true,
			isSearchable: true,
			isPartiallySelected: false,
			isFilterable: true,
			filterKey: 'name',
			lookupConstant: lookupRouteName.state,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			filterType: 1,
			getDistinctValues: true,
			columnKey: 'shippingCity',
			title: 'ORDERVIEW.SHIPPINGADDRESSCITY',
			service: 'orderService',
			isSelected: true,
			isFilterable: true,
			isSearchable: true,
			isPartiallySelected: false,
			allItemValues: [],
			selectedValues: [],
			searchContains: '',
		},
		{
			columnKey: 'internalNote',
			title: 'ORDERVIEW.NOTE',
			isSelected: true,
			isFilterable: false,
		},
	],
};



// WEBPACK FOOTER //
// ./src/common/constants/reportConstants.js